(function(core) {
	var trigger = Onicon.trigger, protocol = Onicon.protocol, formatter = Onicon.formatter;
	var ia = {
		enabled : true,

		items : {},
		connects : {},

		current_map : null,
		current_item : null,
		user_name : '',
		run_item : 0,

		history : [],

		working :  false,
		send_cb_save : null,

		init : function() {
			trigger.bind(trigger.EV_PACKET, function(packet) {
				if(packet.flag == protocol.SERVER_CODE_RUN_IA_MAP) {
					ia._resetState();
					ia.current_map = packet.map;
					ia.user_name = packet.ia_user_name;
					ia.run_item = packet.start_item ? packet.start_item : ia.current_map.start_item;

					for(var i = 0; i < ia.current_map.items.length; i++) {
						var item = ia.current_map.items[i];
						ia.items[item.id] = item;
					}

					for(var i = 0; i < ia.current_map.connects.length; i++) {
						var connect = ia.current_map.connects[i];
						if(!ia.connects[connect.from_id]) {
							ia.connects[connect.from_id] = {};
						}

						ia.connects[connect.from_id][connect.out_index] = connect;
					}

					trigger.execute('sas_disable');
					ia.runCurrentMap();
				}
			});

			trigger.bind(trigger.EV_V_OPERATOR_COME_TO_CHAT, function() {
				ia.enabled = false;
				ia.end();
			});

			trigger.bind(trigger.EV_V_OPERATOR_LEAVE_CHAT, function() {
				ia.enabled = true;
			});
		},

		ready : function() {

		},

		end : function(item_id) {
			if(!ia.working) {
				return false;
			}

			if(ia.send_cb_save) {
				core.sendMessage = ia.send_cb_save;
			}
			ia._resetState();
			core.systemMessage('Интеллектуальный помощник отключен.');
			ia.working = false;
		},

		runCurrentMap : function() {
			if(!ia.enabled) {
				Onicon.error('[ia] Disabled');
				return;
			}

			if(!ia.working) {
				ia.working = true;

				ia.processItem(ia.run_item);

				ia.send_cb_save = core.sendMessage;
				var chat_input = core.getById('input-area');

				core.sendMessage = function() {
					var input_value = chat_input.value.replace(/^\s+|\s+$/g, '');
					if(!input_value) {
						core.systemMessage('Ошибка, вы ничего не напечатали.', 'ia-last-mess');
						return;
					}

					if( (ia.current_item.misses >= 2 && ia.connects[ia.current_item.id]) || (!ia.connects[ia.current_item.id])) {
						core.sendChatMessage(ia._getHistory() + '\n' + input_value);
						core.systemMessage('Ваш вопрос передан оператору, пожалуйста, ожидайте ответ.', 'ia-last-mess');
						ia.end();
						return;
					}

					var success_search_results = [];
					var all_search_results = [];
					var free_input = false;

					for(var out_id in ia.connects[ia.current_item.id]) {
						var connect = ia.connects[ia.current_item.id][out_id];

						if(connect.text.indexOf('*') === 0) {
							free_input = out_id;
							continue;
						}

						all_search_results.push(connect);
						if(connect.text.match(input_value)) {
							success_search_results.push(connect);
						}
					}

					var getTexts = function(connects) {
						var res_array = [];
						for(var i = 0; i < connects.length; i++) {
							res_array.push(connects[i].text);
						}

						return res_array.join('; ');
					}

					if(success_search_results.length == 0) {
						if(free_input) {
							ia.out(ia.current_item.id, free_input);
						} else {
							ia.current_item.misses++;
							core.systemMessage('Пожалуйста, выберите один из вариантов: ' + getTexts(all_search_results) +  '.', 'ia-last-mess');
						}
					} else if(success_search_results.length == 1) {
						ia.out(ia.current_item.id, success_search_results[0].out_index);
					} else { // > 1
						ia.current_item.misses++;
						core.systemMessage('Пожалуйста, уточните Ваш ответ, выберите один из вариантов: ' + getTexts(success_search_results) + '.', 'ia-last-mess');
					}
					chat_input.value = '';
				};
			} else {
				Onicon.error('[ia] Already in use')
			}
		},

		out : function(item_id, num) {
			if(!ia.working) {
				core.systemMessage('Работа интеллектуального помощника уже завершена.', 'ia-stopped');
				return false;
			}
			var connect = ia.connects[item_id][num], text = '';

			if(item_id != ia.current_item.id) {
				ia._cutHistory(item_id);
			}

			if(connect.text.indexOf('*') === 0) { // free input
				text = (connect.text.length > 1 ? connect.text.replace('*', '') : 'input') +  ':' + core.getById('input-area').value;
			} else {
				text = connect.text;
			}

			ia.history.push({
				item_id : item_id,
				text : text
			});

			core.drawMessage({
				sender_id : core.user_id,
				sender_name : 'You',
				message : text,
				post_date : Onicon.lib('datesync').correct(new Date().getTime()/1000, false, true)
			});

			core.scrollMessageArea();

			if(connect.to_id) {
				ia.processItem(connect.to_id);
			} else {
				if(core.current_state == core.STATE_ONLINE) {
					core.sendChatMessage(ia._getHistory());
					core.systemMessage('Ваш вопрос передан оператору, пожалуйста, ожидайте ответ.');
					ia.end();
				} else {
					// offline action
					ia.end();
				}
			}
		},

		processItem : function(item_id) {
			if(!item_id) {
				ia.current_item = ia.current_map.items[0];
			} else {
				ia.current_item = ia.items[item_id];
			}

			ia.current_item.misses = 0;

			core.drawMessage({
				sender_id : 0,
				sender_name : (ia.user_name ? ia.user_name : 'Помощник'),
				message : ia.current_item.content,
				post_date : Onicon.lib('datesync').correct(new Date().getTime()/1000, false, true)
			});

			core.scrollMessageArea();
		},

		_getHistory : function() {
			var history = [ia.current_map.name];
			for(var i = 0; i < ia.history.length; i++) {
				history.push(ia.history[i].text);
			}

			return history.join('->');
		},

		_cutHistory : function(item_id) {
			var cut_index = null;
			for(var i = 0; i < ia.history.length; i++) {
				if(item_id == ia.history[i].item_id) {
					cut_index = i;
					break;
				}
			}

			if(cut_index) {
				ia.history = ia.history.slice(0, cut_index);
			}
		},

		_resetState : function() {
			ia.current_map = null;
			ia.current_item = null;
			ia.connects = {};
			ia.items = {};
			ia.history = [];
		}
	};
	Onicon.lib('ia', ia, true);
})(Onicon.core);